import { createModule } from '../../createModule';
export const createHedgingAPI = createModule(({ http }) => {
    return {
        getHedging: async (params) => {
            const res = await http.get(`/v2/hedging/fxfwd`, {
                params,
            });
            return res;
        },
        updateHedging: async (body) => {
            const res = await http.patch(`/v2/hedging/fxfwd`, { body: body });
            return res;
        },
        resetHedgingRow: async (params) => {
            const res = await http.delete(`/v2/hedging/fxfwd/reset/${params.deal_reference}`);
            return res;
        },
        bookHedging: async (body) => {
            const res = await http.post(`/v2/hedging/fxfwd/book`, { body: body });
            return res;
        },
        unwindMaturing: async (body) => {
            const res = await http.post(`/v2/hedging/fxfwd/unwind`, { body: body });
            return res;
        },
        getMaturing: async (params) => {
            const res = await http.get(`/v2/hedging/maturing/fxfwd`, {
                params,
            });
            return res;
        },
    };
});
